import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContextp2qc4rbktyej as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { Builder3moivcm5iuump as Builder_1 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  flowOn2q2f1gsn1yu9y as flowOn,
  buffer2o7vhreze5nfc as buffer,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor28nn2rq891clj as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.b63_1 = $this_channelFlow;
      }
      *c63(it, $completion) {
        yield* this.b63_1.s1a(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c63(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.c63(it, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.d63_1 = this$0;
        this.e63_1 = $apolloRequest;
        this.f63_1 = $throwing;
        this.g63_1 = $this_channelFlow;
      }
      *r1f($this$withContext, $completion) {
        var tmp = this.d63_1.h63(this.e63_1, this.f63_1);
        var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0(this.g63_1);
        yield* tmp.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.r1f($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_2() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.i63_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.j63_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.k63_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.l63_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.m63_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.n63_1 = ArrayList().p2();
        this.o63_1 = this.n63_1;
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_4.p63_1 = ArrayList().p2();
        this.q63_1 = this.p63_1;
        this.r63_1 = Companion_getInstance().u42_1;
        this.s63_1 = null;
        this.t63_1 = null;
        this.u63_1 = null;
        this.v63_1 = null;
        this.w63_1 = null;
        this.x63_1 = null;
        this.y63_1 = null;
        this.z63_1 = null;
        this.a64_1 = null;
        this.b64_1 = null;
        this.c64_1 = null;
        this.d64_1 = null;
        this.e64_1 = null;
        this.f64_1 = null;
        this.g64_1 = null;
        this.h64_1 = null;
        this.i64_1 = null;
        this.j64_1 = null;
        this.k64_1 = null;
        this.l64_1 = null;
        this.m64_1 = null;
        this.n64_1 = null;
        this.o64_1 = null;
        this.p64_1 = true;
      }
      q64() {
        return this.i63_1.p37();
      }
      r64() {
        return plus(plus(plus(this.j63_1, this.k63_1), this.l63_1), this.m63_1);
      }
      h43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.p64_1 = sendEnhancedClientAwareness;
        return this;
      }
      g43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.m64_1 = failFastIfOffline;
        return this;
      }
      s64(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.k64_1 = retryOnError;
        return this;
      }
      t64(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.l64_1 = retryOnErrorInterceptor;
        return this;
      }
      u64(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.n64_1 = cacheInterceptor;
        return this;
      }
      v64(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.o64_1 = autoPersistedQueryInterceptor;
        return this;
      }
      y42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.s63_1 = httpMethod;
        return this;
      }
      z42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.t63_1 = httpHeaders;
        return this;
      }
      b43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.u63_1 = sendApqExtensions;
        return this;
      }
      c43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.v63_1 = sendDocument;
        return this;
      }
      d43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.w63_1 = enableAutoPersistedQueries;
        return this;
      }
      e43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.x63_1 = canBeBatched;
        return this;
      }
      w64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.b64_1 = serverUrl;
        return this;
      }
      x64(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.b64_1 = httpServerUrl;
        return this;
      }
      y64(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.c64_1 = httpEngine;
        return this;
      }
      z64(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.g64_1 = httpExposeErrorBody;
        return this;
      }
      a65(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.n63_1.a5();
        this.n63_1.u2(httpInterceptors);
        return this;
      }
      b65(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.d64_1 = webSocketServerUrl;
        return this;
      }
      c65(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.j64_1 = webSocketServerUrl;
        return this;
      }
      d65(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.e64_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      e65(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.f64_1 = wsProtocolFactory;
        return this;
      }
      f65(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.h64_1 = webSocketEngine;
        return this;
      }
      g65(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.i64_1 = webSocketReopenWhen;
        return this;
      }
      h65(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.y63_1 = networkTransport;
        return this;
      }
      i65(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.z63_1 = subscriptionNetworkTransport;
        return this;
      }
      j65(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.i63_1.a5();
        this.i63_1.k46(customScalarAdapters);
        return this;
      }
      k65(listeners) {
        // Inline function 'kotlin.apply' call
        this.p63_1.a5();
        this.p63_1.u2(listeners);
        return this;
      }
      l65(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.a64_1 = dispatcher;
        return this;
      }
      w42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.r63_1 = executionContext;
        return this;
      }
      p37() {
        return new (ApolloClient())(this.k38());
      }
      k38() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_2())()).j65(this.i63_1.p37());
        this_0.j63_1.u2(this.j63_1);
        this_0.k63_1.u2(this.k63_1);
        this_0.l63_1.u2(this.l63_1);
        this_0.m63_1.u2(this.m63_1);
        return this_0.l65(this.a64_1).w42(this.r63_1).y42(this.s63_1).z42(this.t63_1).x64(this.b64_1).y64(this.c64_1).z64(this.g64_1).a65(this.o63_1).b43(this.u63_1).c43(this.v63_1).d43(this.w63_1).e43(this.x63_1).h65(this.y63_1).i65(this.z63_1).b65(this.d64_1).c65(this.j64_1).f65(this.h64_1).g65(this.i64_1).d65(this.e64_1).e65(this.f64_1).s64(this.k64_1).t64(this.l64_1).u64(this.n64_1).v64(this.o64_1).g43(this.m64_1).k65(this.q63_1).h43(this.p64_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_2);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.m65_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.m65_1(value, $completion);
      }
      i5() {
        return this.m65_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.n65_1 = this$0;
        this.o65_1 = $apolloRequest;
        this.p65_1 = $throwing;
      }
      *q65($this$channelFlow, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.n65_1.p62_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.r65(this.o65_1);
        }
        try {
          yield* withContext(this.n65_1.f62_1.s65_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0(this.n65_1, this.o65_1, this.p65_1, $this$channelFlow), $completion);
        }finally {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = this.n65_1.p62_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            element_0.u65(this.o65_1);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.q65((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.q65($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      *c63(response, $completion) {
        if (!(response.s44_1 == null)) {
          throw ensureNotNull(response.s44_1);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c63(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.c63(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.e62_1 = builder;
        this.i62_1 = this.e62_1.r64();
        this.j62_1 = this.e62_1.q64();
        this.k62_1 = this.e62_1.n64_1;
        this.l62_1 = this.e62_1.o64_1;
        this.m62_1 = this.e62_1.k64_1;
        this.n62_1 = this.e62_1.l64_1;
        this.o62_1 = this.e62_1.m64_1;
        this.p62_1 = this.e62_1.q63_1;
        this.q62_1 = this.e62_1.p64_1;
        this.r62_1 = this.e62_1.r63_1;
        this.s62_1 = this.e62_1.s63_1;
        this.t62_1 = this.e62_1.t63_1;
        this.u62_1 = this.e62_1.u63_1;
        this.v62_1 = this.e62_1.v63_1;
        this.w62_1 = this.e62_1.w63_1;
        this.x62_1 = this.e62_1.x63_1;
        var tmp = this;
        var tmp_0;
        if (!(this.e62_1.y63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.b64_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.c64_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.e62_1.o63_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.g64_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.e62_1.y63_1);
        } else {
          // Inline function 'kotlin.check' call
          if (!!(this.e62_1.b64_1 == null)) {
            var message_3 = "Apollo: 'serverUrl' is required";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).w64(ensureNotNull(this.e62_1.b64_1));
          if (!(this.e62_1.c64_1 == null)) {
            this_0.b66(ensureNotNull(this.e62_1.c64_1));
          }
          if (!(this.e62_1.g64_1 == null)) {
            this_0.c66(ensureNotNull(this.e62_1.g64_1));
          }
          tmp_0 = this_0.d66(this.e62_1.o63_1).p37();
        }
        tmp.g62_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.e62_1.z63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.d64_1 == null)) {
            var message_4 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.h64_1 == null)) {
            var message_5 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.e64_1 == null)) {
            var message_6 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.f64_1 == null)) {
            var message_7 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.i64_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          // Inline function 'kotlin.check' call
          if (!(this.e62_1.j64_1 == null)) {
            var message_9 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_9));
          }
          tmp_2 = ensureNotNull(this.e62_1.z63_1);
        } else {
          var tmp0_elvis_lhs = this.e62_1.d64_1;
          var url = tmp0_elvis_lhs == null ? this.e62_1.b64_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.g62_1;
          } else {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_1())()).w64(url);
            if (!(this.e62_1.h64_1 == null)) {
              this_1.k66(ensureNotNull(this.e62_1.h64_1));
            }
            if (!(this.e62_1.e64_1 == null)) {
              this_1.l66(ensureNotNull(this.e62_1.e64_1));
            }
            if (!(this.e62_1.f64_1 == null)) {
              this_1.m66(ensureNotNull(this.e62_1.f64_1));
            }
            if (!(this.e62_1.i64_1 == null)) {
              this_1.n66(this.e62_1.i64_1);
            }
            if (!(this.e62_1.j64_1 == null)) {
              this_1.o66(this.e62_1.j64_1);
            }
            tmp_3 = this_1.p37();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.h62_1 = tmp_2;
        var tmp1_elvis_lhs = this.e62_1.a64_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.f62_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.y62_1 = new (NetworkInterceptor())(this.g62_1, this.h62_1);
      }
      p66(query) {
        return ApolloCall().c62(this, query);
      }
      q66(mutation) {
        return ApolloCall().c62(this, mutation);
      }
      l6() {
        cancel(this.f62_1.t65_1);
        this.g62_1.jz();
        this.h62_1.jz();
      }
      z62(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flowOn(flow, Dispatchers_getInstance().y12_1), 2147483647);
      }
      h63(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.v43();
        this_0.w42(this.f62_1.i44(this.j62_1).i44(apolloClient.r62_1).i44(this_0.j42_1));
        var tmp0_elvis_lhs = this_0.k42_1;
        this_0.y42(tmp0_elvis_lhs == null ? apolloClient.s62_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.n42_1;
        this_0.b43(tmp1_elvis_lhs == null ? apolloClient.u62_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.o42_1;
        this_0.c43(tmp2_elvis_lhs == null ? apolloClient.v62_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.m42_1;
        this_0.d43(tmp3_elvis_lhs == null ? apolloClient.w62_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.q42_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.t62_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.l42_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.z42(headers);
        var tmp4_elvis_lhs = this_0.p42_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.x62_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.a43('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.r42_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.m62_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.f43(tmp);
        var tmp7_elvis_lhs = this_0.s42_1;
        this_0.g43(tmp7_elvis_lhs == null ? apolloClient.o62_1 : tmp7_elvis_lhs);
        this_0.h43(apolloClient.q62_1);
        var request = this_0.p37();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.e62_1.j63_1);
        if (!(this.k62_1 == null)) {
          this_2.i2(this.k62_1);
        }
        this_2.u2(this.e62_1.k63_1);
        if (!(this.l62_1 == null)) {
          this_2.i2(this.l62_1);
        }
        this_2.u2(this.e62_1.l63_1);
        var tmp0_elvis_lhs_2 = this.n62_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.e62_1.m63_1);
        this_2.i2(this.y62_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).t66(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_2 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
